import { Hint as e } from "../../components/hint.mjs";
import { jsx as t } from "react/jsx-runtime";
//#region src/extensions/font-family-extension/utils.tsx
var n = /* @__PURE__ */ function(e) {
	return e.Adaptive = "\"SF Pro Display\", system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\"", e.Arial = "Arial, Helvetica, sans-serif", e.ArialBlack = "Arial Black, Gadget, sans-serif", e.Lucida = "Lucida sans unicode,lucida grande,sans-serif", e.Verdana = "verdana,geneva,sans-serif", e.Tahoma = "tahoma,geneva,sans-serif", e.TrebuchetMS = "trebuchet ms,helvetica,sans-serif", e.TimesNewRoman = "times new roman,times,serif", e.Georgia = "georgia, serif", e.Garamond = "garamond, serif", e.CourierNew = "courier new,courier,monospace", e.BrushScriptMT = "brush script mt, cursive", e.Helvetica = "Helvetica, Arial, sans-serif", e.ComicSansMS = "Comic Sans MS, sans-serif", e.Impact = "Impact, Charcoal, sans-serif", e;
}({}), r = (e) => (e.split(",")[0] ?? "").toLowerCase().replace(/["']/g, "").replace(/,/g, "_"), i = (e) => {
	switch (r(e)) {
		case r("\"SF Pro Display\", system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\""): return "Adaptive";
		case r("Arial, Helvetica, sans-serif"): return "Arial";
		case r("Arial Black, Gadget, sans-serif"): return "Arial Black";
		case r("Lucida sans unicode,lucida grande,sans-serif"): return "Lucida";
		case r("verdana,geneva,sans-serif"): return "Verdana";
		case r("tahoma,geneva,sans-serif"): return "Tahoma";
		case r("trebuchet ms,helvetica,sans-serif"): return "Trebuchet MS";
		case r("times new roman,times,serif"): return "Times New Roman";
		case r("georgia, serif"): return "Georgia";
		case r("garamond, serif"): return "Garamond";
		case r("courier new,courier,monospace"): return "Courier New";
		case r("brush script mt, cursive"): return "Brush Script MT";
		case r("Helvetica, Arial, sans-serif"): return "Helvetica";
		case r("Comic Sans MS, sans-serif"): return "Comic Sans MS";
		case r("Impact, Charcoal, sans-serif"): return "Impact";
		default: return e;
	}
}, a = () => Object.values(n).filter((e) => e !== "\"SF Pro Display\", system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\"").map((e) => {
	let n = i(e);
	return {
		value: r(e),
		fontFamilyValue: e,
		label: n,
		customLabel: /* @__PURE__ */ t("div", {
			style: { fontFamily: e },
			children: n
		})
	};
}), o = (a) => Object.values(n).map((n) => {
	let o = i(n), s = n === "\"SF Pro Display\", system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\"";
	return {
		value: r(n),
		fontFamilyValue: n,
		label: o,
		customLabel: /* @__PURE__ */ t("div", {
			style: { fontFamily: n },
			children: s ? /* @__PURE__ */ t(e, {
				inline: !0,
				passive: !0,
				label: a("font_family.adaptive_hint"),
				children: a("font_family.adaptive")
			}) : o
		})
	};
});
//#endregion
export { n as FontFamilyEnum, o as getEmailFontFamilyOptionsData, r as getFontFamilyCode, i as getFontFamilyLabel, a as getFontFamilyOptionsData };
